import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class MaintenanceService {
  // CST → UTC conversion for Nov 8, 2025
  // private maintenanceStartUTC = new Date(Date.UTC(2025, 10, 8, 14, 0, 0)); // 8 AM CST = 14:00 UTC
  // private maintenanceEndUTC = new Date(Date.UTC(2025, 10, 8, 23, 0, 0));   // 5 PM CST = 23:00 UTC
  private maintenanceStartUTC = new Date(Date.UTC(2026, 4, 13, 14, 0, 0)); // 13 May 2026 8:00 AM CST = 14:00 UTC
  private maintenanceEndUTC = new Date(Date.UTC(2026, 4, 16, 23, 0, 0));   // 16 May 2026 5:00 PM CST = 23:00 UTC
  isActive(): boolean {
    const nowUTC = new Date();
    return (
      nowUTC.getTime() >= this.maintenanceStartUTC.getTime() &&
      nowUTC.getTime() <= this.maintenanceEndUTC.getTime()
    );
  }
}


